import React,{useState} from 'react';
import  web from '../Images/r8.jpg';
const Contact=()=>{
    const [data,setData]=useState({
      name:"",
      contactno:"",
      email:"",
      msg:""
    });
    const formSubmit=(event)=>{
     
      try {
        let result = fetch(
          "https://webhook.site/24ad3f56-3760-42d7-9e4b-639af3657c87",
          {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
            body: JSON.stringify({
              "name":data.name,
              "contactno":data.contactno,
              "email":data.email,
              "msg":data.msg
            }),
          }
        );
        console.log(result)
      } catch (e) {
        console.log(e);
      }
      alert(`${data.name}, your msg is succesfully sent!`)
      event.preventDefault();

  }
  const InputEvent=(event)=>{
const {name,value}= event.target;
setData((preVal)=>{
  return{
    ...preVal,[name]:value,
  }
})
  }

  return (
    <>
  <section id="header" className="d-flex align-items-center justify-content-center pb-5 pt-5">
      <div className="container-fluid nav_bg">
        <div className="row">
          <div className="col-8 mx-auto">
          <div className="row">
            <div className="col-lg-4 pt-3 pt-lg-5 order-1 order-lg-2 d-flex justify-content-center flex-column">
              
              <h1><strong className="brand-name " id="c">Contact US</strong> </h1>
             
              <div className="mt-3">
              
              </div>
            </div>
            <div class="col-lg-8 order-2 order-lg-1 header-img">
              <img src={web} className="img-fluid animated" alt="home-img"/>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
     <div className="container contact_div">
     <div className="row">
       <div className="Col-md-6 col-lg-6 col-10 mx-auto">
         <form className="m-2" onSubmit={formSubmit}>
         <div class="mb-3">
  <label  class="form-label">Full Name</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="name" name="name" value={data.name} onChange={InputEvent} required/>
</div>
<div class="mb-3">
  <label  class="form-label">Contact No.</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="contact no." name="contactno" value={data.contactno} onChange={InputEvent} required/>
</div>
<div class="mb-3">
  <label  class="form-label">Email address</label>
  <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com" name="email" value={data.email} onChange={InputEvent} required/>
</div>
<div class="mb-3">
  <label class="form-label">Message</label>
  <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" name="msg" value={data.msg} onChange={InputEvent} required></textarea>
</div>
<button type="submit" class="btn btn-primary p-2" style={{borderRadius:"30px"}}>Submit</button>
         </form>
       </div>
       </div>

     </div>
     <br/>
     </>
  );
};

export default Contact;
